import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Work from "./Work";
import EffectCanvas from "../components/water_effect/EffectCanvas";
import { scrollToId } from "../functions/scroll";
import downArrow from "../images/down-arrow.png";

const Home = () => {
  const history = useHistory();
  const location = useLocation();

  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < breakpoint);

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  const isMobile = useIsMobile();

  useEffect(() => {
    if (location.pathname !== "/") return;
    const hash = window.location.hash;

    if (hash !== "") {
      scrollToId(hash, 800);
    } else if (location.state && location.state.scrollToProjects) {
      const delay = 1000;
      history.replace({
        pathname: "/",
        hash: "#projects",
      });
      setTimeout(() => {
        const el = document.querySelector("#projects");
        if (el) {
          scrollToId("#projects", 1200);
        }
      }, delay);

      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleScrollToProjects = (e) => {
    e.preventDefault();
    scrollToId("#projects", 1200);
  };

  return (
    <div>
      <div className="content fill-page fill-width home_background">
        <div className="landing-intro">
          <h1>
            <em>Jade Law</em> is an abstract artist visualizing the emotional
            language of music.
          </h1>
        </div>

        {!isMobile && <EffectCanvas />}

        <div className="horizontal-menu">
          <h5>
            <a onClick={handleScrollToProjects}>Explore artworks</a>
            <a onClick={handleScrollToProjects}>
              <img src={downArrow} alt="Projects" />
            </a>
          </h5>
        </div>
      </div>

      <Work />
    </div>
  );
};

export default Home;
